export const _adr = {
  Root: process.env.REACT_APP_ROOT_PAGE,
  Home: "",
  Packages: "/packages",
  PackagePrefactor: "/prefactor",
  PackageFactor: "/factor",
  DirectCharge: "/directcharge",
};
